import BigNumber from "bignumber.js";

export const HALF_DOWN = "ROUND_HALF_DOWN";
export const HALF_UP = "ROUND_HALF_UP";

export function round(amount = 0, decimals = 0, rounding = HALF_UP) {
    if (!amount && amount !== 0) return amount;

    return new BigNumber(amount).decimalPlaces(decimals, BigNumber[rounding]).toNumber();
}
